import { addressLocationsValidate } from '../../application/dtos/address_locations_validate'

export class AddressLocationsEntity {
    constructor({zipcode, state, city}){
        this.zipcode = zipcode;
        this.state = state;
        this.city = city;
    }

    isValid() {
        return addressLocationsValidate(this);
    }
}